import { ORDER_STATUS_IN_PROGRESS } from 'features/order-tracker/services/constants';

import { TodaysApptUserFlowSteps } from '../../constants';

const TITLE = 'Engineer visit';
const ENGINEER_DUE_TODAY_STATUS = 'ENGINEER DUE TODAY';

const MAIN_ACTION_BUTTON_TYPE = 'mainAction';
const SECONDARY_ACTION_BUTTON_TYPE = 'secondaryAction';

const CANT_MAKE_IT_TODAY_LABEL = `I can’t make it today`;
const CANT_WAIT_ANYMORE_LABEL = `I can’t wait anymore`;
const TRACK_ANOTHER_ORDER_LABEL = 'Track another order';
const ARRIVED_LABEL = 'Arrived';
const NOT_ARRIVED_LABEL = 'Not arrived';
const BACK_LABEL = 'Back';

const ANALYTICS_BTN_PREFIX = 'Openreach engineer appointment:';
const ANALYTICS_BTN_CANT_MAKE_IT_TODAY = ANALYTICS_BTN_PREFIX + CANT_MAKE_IT_TODAY_LABEL;
const ANALYTICS_BTN_TRACK_ANOTHER_ORDER = ANALYTICS_BTN_PREFIX + TRACK_ANOTHER_ORDER_LABEL;
const ANALYTICS_BTN_BACK = ANALYTICS_BTN_PREFIX + BACK_LABEL;
const ANALYTICS_BTN_ARRIVED = ANALYTICS_BTN_PREFIX + ARRIVED_LABEL;
const ANALYTICS_BTN_NOT_ARRIVED = ANALYTICS_BTN_PREFIX + NOT_ARRIVED_LABEL;
const ANALYTICS_EVENT_BEFORE = 'before';
const ANALYTICS_EVENT_DURING = 'during';
const ANALYTICS_EVENT_AFTER = 'after';

export const MAP_CONTENT_BY_STEP = {
  [TodaysApptUserFlowSteps.Init]: {
    title: TITLE,
    status: ORDER_STATUS_IN_PROGRESS,
    statusText: ENGINEER_DUE_TODAY_STATUS,
    analyticsEvent: ANALYTICS_EVENT_BEFORE,
    messages: [
      `Your engineer is due to attend today.  If any of the details below are incorrect then contact us immediately.`,
      `If you can't make your appointment or want to track another order, click below.`,
    ],
    actionSteps: [
      {
        type: MAIN_ACTION_BUTTON_TYPE,
        label: CANT_MAKE_IT_TODAY_LABEL,
        isChatButton: true,
        analytics: ANALYTICS_BTN_CANT_MAKE_IT_TODAY,
      },
      {
        type: SECONDARY_ACTION_BUTTON_TYPE,
        label: TRACK_ANOTHER_ORDER_LABEL,
        analytics: ANALYTICS_BTN_TRACK_ANOTHER_ORDER,
        isTrackAnotherOrderButton: true,
      },
    ],
  },
  [TodaysApptUserFlowSteps.HalfAnHourBefore]: {
    title: TITLE,
    status: ORDER_STATUS_IN_PROGRESS,
    statusText: ENGINEER_DUE_TODAY_STATUS,
    analyticsEvent: ANALYTICS_EVENT_DURING,
    messages: [
      `It’s getting close to the end of your scheduled slot, so hopefully your engineer has arrived and everything is 
      going well. If not, please see guidance below.`,
      `If you've not yet heard from your engineer, please wait a bit longer and check back here in 30 minutes. 
      If you can't wait any longer or want to track another order, click below.`,
    ],
    actionSteps: [
      {
        type: MAIN_ACTION_BUTTON_TYPE,
        label: CANT_WAIT_ANYMORE_LABEL,
        isChatButton: true,
        analytics: ANALYTICS_BTN_CANT_MAKE_IT_TODAY,
      },
      {
        type: SECONDARY_ACTION_BUTTON_TYPE,
        label: TRACK_ANOTHER_ORDER_LABEL,
        analytics: ANALYTICS_BTN_TRACK_ANOTHER_ORDER,
        isTrackAnotherOrderButton: true,
      },
    ],
  },
  [TodaysApptUserFlowSteps.EndOfScheduledTimeSlot]: {
    title: TITLE,
    status: ORDER_STATUS_IN_PROGRESS,
    statusText: ENGINEER_DUE_TODAY_STATUS,
    analyticsEvent: ANALYTICS_EVENT_AFTER,
    messages: [
      `Your appointment slot has now ended and it’s likely your engineer has completed the work. 
      Once we receive confirmation from our supplier, we’ll update the order status.`,
      'Has your engineer not arrived?',
    ],
    actionSteps: [
      {
        type: MAIN_ACTION_BUTTON_TYPE,
        label: NOT_ARRIVED_LABEL,
        isChatButton: true,
        analytics: ANALYTICS_BTN_NOT_ARRIVED,
      },
      {
        type: SECONDARY_ACTION_BUTTON_TYPE,
        nextStep: TodaysApptUserFlowSteps.EndOfScheduledTimeSlotSuccess,
        label: ARRIVED_LABEL,
        hasSuccessBanner: true,
        analytics: ANALYTICS_BTN_ARRIVED,
      },
    ],
  },
  [TodaysApptUserFlowSteps.EndOfScheduledTimeSlotSuccess]: {
    title: TITLE,
    status: ORDER_STATUS_IN_PROGRESS,
    statusText: ENGINEER_DUE_TODAY_STATUS,
    analyticsEvent: ANALYTICS_EVENT_AFTER,
    messages: [
      `Your appointment slot has now ended and it’s likely your engineer has completed the work. 
      Once we receive confirmation from our supplier, we’ll update the order status.`,
      'Has your engineer not arrived?',
    ],
    actionSteps: [
      {
        type: MAIN_ACTION_BUTTON_TYPE,
        label: ARRIVED_LABEL,
        disabled: true,
      },
      {
        type: SECONDARY_ACTION_BUTTON_TYPE,
        nextStep: TodaysApptUserFlowSteps.EndOfScheduledTimeSlot,
        label: BACK_LABEL,
        analytics: ANALYTICS_BTN_BACK,
      },
    ],
  },
};
